/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
// src/utils/iconHelper.tsx
import React from 'react';
import { IconType, IconBaseProps } from 'react-icons';

export const useIcon = (Icon: IconType) => {
    return React.useMemo(
        () => (props: IconBaseProps) => React.createElement(Icon as any, props),
        [Icon]
    );
};

// Or as a component wrapper:
export const IconWrapper: React.FC<{ icon: IconType } & IconBaseProps> = ({
    icon: Icon,
    ...props
}) => {
    return React.createElement(Icon as any, props);
};